import styled from "styled-components";
export const OrderRequestWrap = styled.div`
    display: flex;
    gap: 20px;
    flex-direction: column;
    margin-bottom: 30px;

    @media (min-width: 992px) {
        flex-direction: row;
    }

    .headMenu {
        font-size: 14px;
        line-height: 18px;

        .heading {
            display: block;
            font-size: 18px;
            line-height: 22px;
            font-weight: 600;
            color: var(--text-color);
            margin-bottom: 5px;

            @media (min-width: 768px) {
                font-size: 20px;
                line-height: 24px;
            }
        }
    }
    .orderRequest {
        flex-grow: 1;

        @media (min-width: 992px) {
            width: 58%;
        }
        @media (min-width: 1200px) {
            width: auto;
        }
    }
    .parentRecentOrder {
        background-color: var(--white);
        border-radius: 15px;
        padding: 15px;
        box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.11);
        min-height: 550px;

        @media (min-width: 768px) {
            padding: 15px 20px;
        }
        @media (min-width: 1400px) {
            padding: 15px 30px;
        }
        .HeadingWrap {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            flex-direction: column;
            margin-bottom: 20px;
            color: var(--gray);
            gap: 10px;

            @media (min-width: 768px) {
                flex-direction: row;
            }

            .order-dropdown {
                position: relative;
                width: 100%;

                @media (min-width: 768px) {
                    max-width: 130px;
                }

                .dropdown {
                    display: flex;
                    justify-content: space-between;
                    gap: 10px;
                    align-items: center;
                    position: relative;
                    border-radius: 15px;
                    border: 1px solid var(--gray-tune, #dfdfdf);
                    text-align: center;
                    font-size: 18px;
                    line-height: 22px;
                    font-weight: 300;
                    padding: 10px;
                    cursor: pointer;
                    p {
                        margin: 0;
                    }
                }
                .styled-select {
                    position: absolute;
                    top: 50px;
                    left: 0;
                    width: 130px;
                    background: var(--white);
                    border: 1px solid var(--gray-tune, #dfdfdf);
                    border-radius: 8px;
                    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
                    text-align: left;
                    font-size: 16px;
                    line-height: 22px;
                    font-weight: 300;
                    padding: 10px 0;
                    z-index: 1;

                    li {
                        padding: 5px 15px;
                        cursor: pointer;
                        color: #313131;
                        &:hover {
                            background: var(--primary);
                            color: var(--white);
                        }
                    }
                }
            }
        }
        .orderHolder {
            display: flex;
            flex-direction: column;
            gap: 16px;
            max-height: 450px;
            overflow-y: auto;
            padding-right: 5px;

            /* Custom scrollbar styling */
            &::-webkit-scrollbar {
                width: 6px;
            }

            &::-webkit-scrollbar-track {
                background: #f1f1f1;
                border-radius: 10px;
            }

            &::-webkit-scrollbar-thumb {
                background: ${({theme}) => theme?.light?.primary || "#888"};
                border-radius: 10px;
            }

            &::-webkit-scrollbar-thumb:hover {
                background: ${({theme}) => theme?.light?.primaryDark || theme?.light?.primary || "#555"};
            }
        }

        .orderRow {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            padding: 16px 0;
            border-bottom: 1px solid #ddd;
            gap: 20px;
            @media (min-width: 768px) {
                align-items: center;
            }
            .orderContent {
                display: flex;
                align-items: center;
                gap: 20px;
                flex-grow: 1;
                .contentHolder {
                    display: flex;
                    flex-direction: row;
                    gap: 10px;
                    flex-grow: 1;
                    justify-content: space-between;
                    flex-direction: column;
                    @media (min-width: 576px) {
                        gap: 20px;
                    }
                    @media (min-width: 768px) {
                        flex-direction: row;
                        gap: 20px;
                    }
                }

                .content {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    flex-grow: 1;
                    justify-content: space-between;
                    &:first-child {
                        align-items: flex-start;
                    }
                }
                .countingWrapper {
                    display: flex;
                    align-items: center;
                    .quantity {
                        margin: 0 20px;
                        font-size: 14px;
                        line-height: 18px;
                        font-weight: 300;
                        @media (min-width: 768px) {
                            font-size: 18px;
                            line-height: 22px;
                        }
                    }
                }
            }
        }
        .orderImage {
            flex-shrink: 0;
            width: 100%;
            max-width: 70px;
            height: 69.53px;
            img {
                object-fit: cover;
            }
        }
        .orderDescription {
            max-width: 200px;
            line-height: 21px;
            strong {
                display: block;
                font-size: 14px;
                line-height: 18px;
                font-weight: 400;
                @media (min-width: 768px) {
                    font-size: 16px;
                    line-height: 20px;
                }
                @media (min-width: 1200px) {
                    font-size: 18px;
                    line-height: 22px;
                }
            }
            span {
                color: #888;
                font-weight: 300;
                font-size: 13px;
                line-height: 17px;
                @media (min-width: 768px) {
                    font-size: 14px;
                    line-height: 18px;
                }
            }
        }
        .orderName {
            max-width: 166px;
            strong {
                display: block;
                font-size: 14px;
                line-height: 18px;
                font-weight: 400;
                @media (min-width: 768px) {
                    font-size: 16px;
                    line-height: 20px;
                }
                @media (min-width: 1200px) {
                    font-size: 18px;
                    line-height: 22px;
                }
            }
            span {
                color: #888;
                font-size: 13px;
                line-height: 17px;
                font-weight: 300;
                @media (min-width: 768px) {
                    font-size: 14px;
                    line-height: 18px;
                }
            }
        }
        .orderActions {
            display: flex;
            gap: 25px;
            @media (min-width: 1200px) {
                flex-direction: row;
                align-items: center;
                @media (max-width: 767px) {
                    flex-direction: column;
                    align-items: flex-start;
                }
            }
        }
        .dropdownWrapper {
            display: flex;
            align-items: center;
            cursor: pointer;
            position: relative;
        }
        .counting {
            margin-left: 8px;
            display: flex;
            font-size: 14px;
            line-height: 18px;
            font-weight: 400;
            @media (min-width: 768px) {
                font-size: 18px;
                line-height: 22px;
            }
        }
        .status {
            display: block;
            padding: 6px 9px;
            border-radius: 40px;
            font-size: 14px;
            line-height: 18px;
            font-weight: 400;
            width: 155px;
            text-align: center;
            background-color: "${({theme}) => theme?.light?.primary50};";
            @media (min-width: 768px) {
                font-size: 16px;
                line-height: 20px;
            }
            &.new_order {
                background-color: #feecdf;
            }
            &.accepted {
                background-color: #ad97bbff;
            }
            &.ready_for_pickup {
                background-color: rgba(217, 255, 230, 1);
            }
            &.preparing {
                background-color: rgba(255, 162, 95, 1);
            }
            &.out_for_delivery {
                background-color: rgba(180, 255, 95, 1);
            }
            &.delivered {
                background-color: #25a3da26;
            }
            &.canceled {
                background-color: #ff2d2d26;
            }
            &.completed {
                background-color: #25a3da26;
            }
        }
        .parentListOrders {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
    }
    .trendingMenus {
        background-color: var(--white);
        border-radius: 15px;
        padding: 15px 20px;
        box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.11);
        height: 100%;
        width: 100%;
        height: 550px;
        overflow-y: scroll;

        @media (min-width: 992px) {
            width: 310px;
        }

        .headMenu {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            text-align: left;
            margin: 0 auto;
            width: 100%;
            max-width: 1200px;
            font-size: 14px;
            line-height: 18px;
            font-weight: 300;
            color: var(--gray);
        }
        .menuSetting {
            display: flex;
            justify-content: space-between;
            margin: 20px 0px;
            .trendingImgWrap {
                position: relative;
                flex-shrink: 0;
                .imgWrap {
                    width: 100%;
                    max-width: 70px;
                    height: 70px;
                }
            }
            .imageText {
                background-color: ${({theme}) => theme?.light?.primary};
                border-radius: 50%;
                padding: 3px;
                height: 25px;
                width: 25px;
                text-align: center;
                position: absolute;
                bottom: -4px;
                left: 50%;
                transform: translateX(-50%);
                display: flex;
                align-items: center;
                justify-content: center;
                border: 2px solid var(--white);
                color: var(--white);
                font-size: 10px;
                line-height: 14px;
                font-weight: 300;
            }
        }
        .borderBottom {
            border-bottom: 1px solid rgb(236, 236, 236);
            margin-bottom: 10px;
            padding-bottom: 10px;
        }
        .textContainer {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            margin-left: 20px;
            .itemName {
                margin-bottom: 6px;
                font-size: 14px;
                line-height: 18px;
                font-weight: 400;
            }
        }
        .menuPrice {
            display: flex;
            justify-content: space-between;
            .itemPrice {
                font-size: 16px;
                line-height: 20px;
                font-weight: 400;
            }
            .itemOrder {
                font-size: 12px;
                line-height: 16px;
                font-weight: 300;
            }
        }
    }
`;
export const DropContent = styled.ul`
    position: absolute;
    right: 0;
    top: 35px;
    background: var(--white);
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    z-index: 10;
    padding: 8px;
    width: 172px;
    opacity: 0;
    visibility: hidden;
    transform: translateY(30px);
    transition: 0.4s;
    &.active {
        opacity: 1;
        visibility: visible;
        transform: translateY(0);
    }
    .dropdownItem {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 8px 12px;
        font-size: 16px;
        line-height: 20px;
        font-weight: 400;
        cursor: pointer;
        &:nth-child(1) {
            color: green;
        }
        &:nth-child(2) {
            color: red;
        }
        &:nth-child(3) {
            color: gray;
        }
    }
`;
